import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Global } from './core/Global';


@Injectable()

export class PermissionsService {
	private url: string = Global.url_seguros
	private _http = inject(HttpClient)


	save(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'permissions', params, {headers: headers})
	}
	update(id: any, params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.patch(this.url + 'permissions/' + id, params, {headers: headers})
	}
	get(menu: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'permissions/get/' + menu, {headers: headers})
	}
}
